<div class="outer"
     [ngStyle]="{'height': height + 'px'}">
  <div class="inner"
       [ngStyle]="{'width': value + '%', 'height': height + 'px'}">
    <div [ngClass]="value > 50 ? 'innerLabel' : 'outerLabel'"
         [textContent]="value | iexNoRoundPercents"
         [ngStyle]="{'line-height': height + 'px'}"
         [attr.data-automation-e2e-selector]="'label'">
    </div>
  </div>
</div>
